import { render, staticRenderFns } from "./SingleAnswerQuestion.vue?vue&type=template&id=db86935a&scoped=true"
import script from "./SingleAnswerQuestion.vue?vue&type=script&lang=js"
export * from "./SingleAnswerQuestion.vue?vue&type=script&lang=js"
import style0 from "./SingleAnswerQuestion.vue?vue&type=style&index=0&id=db86935a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db86935a",
  null
  
)

export default component.exports